import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@src/components/ui/react-hook-form/text-Input/text-input';
import { TextField, InputAdornment } from '@mui/material';

export const PhoneInput = ({
    onChange,
    name = 'phoneNumber',
    value,
    isRHF = false,
    defaultValue = '',
    helperText = '',
    ...props
}) => {
    const formattedValue = () => {
        let newValue = value;
        if (value.length > 3 && value.length <= 6) {
            newValue = value.slice(0, 3) + ' ' + value.slice(3);
        } else if (value.length > 6) {
            newValue = value.slice(0, 3) + ' ' + value.slice(3, 6) + ' ' + value.slice(6, 10);
        }
        return newValue;
    };
    const handleInputChange = e => {
        let value = e.target.value.replace(/\D/g, '');
        value = value.slice(0, 10);
        onChange(value.trim());
    };
    return isRHF ? (
        <TextInput
            name={name}
            label='Phone'
            autoFocus
            onChange={handleInputChange}
            inputMode='numeric'
            value={formattedValue()}
            {...props}
            InputProps={{
                ...(props.InputProps || {}),
                startAdornment: (
                    <InputAdornment position='start'>
                        <span>+1</span>
                    </InputAdornment>
                )
            }}
        />
    ) : (
        <TextField
            name={name}
            label='Phone'
            onChange={handleInputChange}
            inputMode='numeric'
            value={formattedValue()}
            error={helperText !== ''}
            helperText={helperText}
            {...props}
            InputProps={{
                ...(props.InputProps || {}),
                startAdornment: (
                    <InputAdornment position='start'>
                        <span>+1</span>
                    </InputAdornment>
                )
            }}
        />
    );
};

PhoneInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isRHF: PropTypes.bool,
    defaultValue: PropTypes.string,
    helperText: PropTypes.string,
    InputProps: PropTypes.object
};
